import { connect } from 'react-redux';
import MobileMenuToggle from './';
import { toggleMobileMenu } from '../../actions/viewActions';
import { calculatedTotalUnreadCount, isMentionedInAnyChat } from '../../helpers/ChatUtils';

const mapStateToProps = state => {
  const { view, chats } = state;
  return {
    mobileMenuOpened: view.mobileMenuOpened,
    unreadMessageCount: calculatedTotalUnreadCount(chats),
    mentioned: isMentionedInAnyChat(chats),
  }
};

const mapDispatchToProps = dispatch => ({
  toggleMobileMenu: visibility => dispatch(toggleMobileMenu(visibility)),
});


export default connect(mapStateToProps, mapDispatchToProps)(MobileMenuToggle);
